module.exports = __webpack_public_path__ + "testimonial2.png?437c543ccc2562cf8ddcc9d2d8eb3658";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonial2.png
// module id = 367
// module chunks = 0